export const INBOX_CHANGED_EVENT = "inbox-notification-changed";

export function notifyInboxChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(INBOX_CHANGED_EVENT));
}

export function inboxApiPaths(role) {
  const owner = role === "owner";
  return {
    list: owner ? "/api/notifications/inbox/owner" : "/api/notifications/inbox/user",
    unread: owner ? "/api/notifications/unread-count/owner" : "/api/notifications/unread-count/user",
    read: owner ? "/api/notifications/inbox/read/owner" : "/api/notifications/inbox/read/user",
  };
}

function pathFromUrl(url, fallback) {
  const raw = String(url || "").trim();
  if (!raw) return fallback;
  try {
    const u = new URL(raw, typeof window !== "undefined" ? window.location.origin : "https://www.lememeprix.fr");
    return `${u.pathname}${u.search}` || fallback;
  } catch {
    return raw.startsWith("/") ? raw : `/${raw}`;
  }
}

export function inboxItemPath(item, role = "user") {
  const data = item?.data && typeof item.data === "object" ? item.data : {};
  const type = String(item?.type || data.type || "");
  const url = String(data.url || "");
  const orderId = data.orderId ? String(data.orderId) : "";

  if (type === "preorder_reminder") return pathFromUrl(url, "/favorites");
  if (type === "drive_approach_reminder" && orderId) return `/order/${orderId}?approach=1`;
  if (type === "post_pickup_share") return pathFromUrl(url, "/feed");
  if (type === "user_follow") {
    if (url) return pathFromUrl(url, "/feed");
    const code = String(data.userRefCode || "").trim();
    return code ? `/u/${encodeURIComponent(code)}` : "/feed";
  }
  if (type === "post_like" || type === "post_comment") {
    if (url) return pathFromUrl(url, "/feed");
    const postId = String(data.postId || "").trim();
    if (!postId) return "/feed";
    return type === "post_comment" ? `/t/${postId}?comments=1` : `/t/${postId}`;
  }
  if (type === "taste_try") {
    if (url) return pathFromUrl(url, "/feed");
    return "/feed";
  }
  if (type === "restaurant_chat") {
    if (url) return pathFromUrl(url, role === "owner" ? "/restaurant/messages" : "/messages");
    return role === "owner" ? "/restaurant/messages" : "/messages";
  }
  if (type === "restaurant_follow") {
    return role === "owner" ? "/restaurant/feed" : "/feed";
  }
  if (type === "order_chat") {
    if (url) return pathFromUrl(url, role === "owner" ? "/restaurant/messages" : "/messages");
    if (orderId) return role === "owner" ? `/restaurant/messages/${orderId}` : `/messages/${orderId}`;
    return role === "owner" ? "/restaurant/messages" : "/messages";
  }

  if (role === "owner") {
    if (url.includes("/restaurant/")) return pathFromUrl(url, "/restaurant/orders");
    if (orderId) return `/restaurant/orders/${orderId}`;
    return "/restaurant/orders";
  }

  if (orderId) return `/order/${orderId}`;
  if (url) return pathFromUrl(url, "/notifications");
  return "/notifications";
}
